<template>
    <div
        id="be-dashboard"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />

            <main class="mt-5">
                <div class="container-fluid">
                    <div class="sezioni row d-flex justify-content-center flex-wrap mt-3">
                        <backend-dashboard-box
                            :title="$t('Ordini')"
                            :viewAll="$t('Vedi tutti')"
                            @viewAllClicked="goToOrders"
                        >
                            <slot>
                                <backend-dashboard-box-ordini
                                    :orders="orders"
                                    @viewAllClicked="goToOrders"
                                />
                            </slot>
                        </backend-dashboard-box>
                        <backend-dashboard-box
                            :title="$t('Attività recenti')"
                            :viewAll="$t('Vedi tutte')"
                            @viewAllClicked="goToRecentActivities"
                        >
                            <slot>
                                <backend-dashboard-box-recenti
                                    :events="eventsStats"
                                    @viewAllClicked="goToRecentActivities"
                                />
                            </slot>
                        </backend-dashboard-box>
                        <backend-dashboard-box
                            title
                            viewAll
                            viewAllHref
                        >
                            <slot>
                                <backend-dashboard-box-crea-gallery />
                            </slot>
                        </backend-dashboard-box>
                    </div>
                </div>
            </main>

            <backend-footer />
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import BackendDashboardBox from "../../components/backend/DashboardBox";
import BackendDashboardBoxOrdini from "../../components/backend/DashboardBoxOrdini";
import BackendDashboardBoxRecenti from "../../components/backend/DashboardBoxRecenti";
import BackendDashboardBoxCreaGallery from "../../components/backend/DashboardBoxCreaGallery";

export default {
    name: "BackendDashboard",

    components: {
        BackendHeader,
        BackendFooter,
        BackendDashboardBox,
        BackendDashboardBoxOrdini,
        BackendDashboardBoxRecenti,
        BackendDashboardBoxCreaGallery
    },

    data() {
        return {
            orders: [],
            eventsStats: []
        };
    },

    mounted() {
        this.orders = [];
        this.load();
    },

    methods: {
        load() {
            return this.$api.backendGetDashboard().then((response) => {
                console.debug("BACKEND_GET_DASHBOARD", response);
                if (response.orders) {
                    this.orders = response.orders;
                }
                if (response.eventsStats) {
                    this.eventsStats = response.eventsStats;
                }
            });
        },

        goToOrders() {
            this.$router.push({ name: "backend-sales-orders" });
        },

        goToRecentActivities() {
            this.$router.push({ name: "backend-recent-gallery-activities" });
        }
    }
};
</script>

<style scoped>
</style>
